import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as api from '../../services/device_type/api_device_type';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListDeviceTypeSaga(feathersApp) {
	yield takeLatest("FETCH_LIST_DEVICE_TYPE", callFetchListDeviceType, feathersApp);
}
function* callFetchListDeviceType(feathersApp, action) {
	const { silent, filters } = action;
	yield common.showProgressListTable(silent);
	try {
		const dataParams = { filters, list_type: 'device_type' };
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield common.showErrorListTable(error);
	}
}

export function* saveDeviceTypeSaga(feathersApp) {
	yield takeEvery("SAVE_DEVICE_TYPE", callSaveDeviceType, feathersApp);
}
function* callSaveDeviceType(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveDeviceType, feathersApp, params);
		yield common.doneSaveRecord(result, 'Device type was saved');
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});
		yield callFetchListDeviceType(feathersApp, { silent: true });

	} catch (e) {
		yield common.showErrorSaveRecord(e);
	}
}

export function* deleteDeviceTypeFromListSaga(feathersApp) {

	yield takeEvery('DELETE_DEVICE_TYPE_FROM_LIST', callDeleteDeviceTypeFromList, feathersApp);
}

function* callDeleteDeviceTypeFromList(feathersApp, action) {
	yield deleteDeviceType(feathersApp, action);
	yield delay(2000);
	yield callFetchListDeviceType(feathersApp, { silent: true });
}

function* deleteDeviceType(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteDeviceType, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.DEVICE_TYPE } });
			yield callFetchListDeviceType(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteDeviceTypeSaga(feathersApp) {
	yield takeEvery('DELETE_DEVICE_TYPE', callDeleteDeviceType, feathersApp);
}

function* callDeleteDeviceType(feathersApp, action) {
	const result = yield deleteDeviceType(feathersApp, action);
	if (result) {
		browserHistory.push('/admin/device_type');
	}
}

export function* fetchDeviceTypeForEditSaga(feathersApp) {
	yield takeEvery('FETCH_DEVICE_TYPE_BY_ID', callFetchDeviceTypeForEdit, feathersApp);
}

function* callFetchDeviceTypeForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.DEVICE_TYPE;
	try {
		if (id) {
			yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchDeviceTypeById, feathersApp, fetchParams);
			yield common.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});
		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
